import { reducers as i18nReducer } from '@altermaind/core/i18n';
import {
  requestsStatusReducerKey,
  requestsStatusReducer,
} from '@altermaind/core/requests-status-management';
import { aspectRootReducer, aspectRootReducerStateKey } from '@/aspect/state';
import { loginRootReducer, loginRootReducerStateKey } from '@/login/state';
import { platformUiReducer } from '../styles/state/reducer';
import { rootReducerStateKey } from '../styles/state/rootReducer';

const staticRootReducer = {
  i18n: i18nReducer,
  [requestsStatusReducerKey]: requestsStatusReducer,
  [rootReducerStateKey]: platformUiReducer,
  [loginRootReducerStateKey]: loginRootReducer,
  [aspectRootReducerStateKey]: aspectRootReducer,
};

export default staticRootReducer;
